module.exports = __webpack_public_path__ + "img/erp-logos_0013_sapb1.b72d5a59.jpg";